import httpClient from '@/api/http-client';

const endpoint = 'api/driving-permits-statistics';

const drivingPermitStatisticsService = {
  getDrivingPermitStatistics: (params) => httpClient.get(endpoint, { params }),

  getDrivingPermitStatisticsChartData: (params) =>
    httpClient.get(`${endpoint}-by-year`, { params }),
};

export default drivingPermitStatisticsService;
